module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://store.i80.com.tw/Trans.php",
      "id": "order-form",
      "method": "POST"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step1),
      expression: "step1"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippinged),
      expression: "shippinged"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "delivery"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippinged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shippingOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.tx
      }
    }, [_vm._v(_vm._s(option.text))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiced),
      expression: "invoiced"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "invoice"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.invoiced = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.invoiceOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                          " + _vm._s(option.text) + "\n                                      ")])
  }))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceShow),
      expression: "invoiceShow"
    }],
    staticClass: "row"
  }, [_vm._m(5, false, false), _vm._v(" "), _vm._m(6, false, false)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shippinged === 'help_yourself'),
      expression: "shippinged === 'help_yourself'"
    }],
    staticClass: "row"
  }, [_vm._m(7, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "cart_list"
  }, [_vm._m(8, false, false), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "list_item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2 hidden-xs"
    }, [_c('figure', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-3"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.price) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.point) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.maximum), function(number) {
      return _c('option', {
        domProps: {
          "value": number
        }
      }, [_vm._v(_vm._s(number))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.point * item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.price * item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('h5', {
      staticClass: "title",
      on: {
        "click": function($event) {
          _vm.DELETE_TO_CART(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })])])])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.totalPoint >= 1000) ? _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("加購專區")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.addon), function(item, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-3 col-xs-3"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]), _vm._v(" "), _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addToCart(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n            \t\t\t\t\t\t\t\t\t\t")])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total_list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-7 col-sm-5 col-xs-12"
  }, [_c('p', [_vm._v("共" + _vm._s(_vm.cart_items) + "件，回饋點數: " + _vm._s(_vm.totalPoint) + "點")])]), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.orderAmount))])])]), _vm._v(" "), _vm._m(10, false, false), _vm._v(" "), _vm._m(11, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.shippingFee))])])]), _vm._v(" "), _vm._m(12, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.invoiceFee))])])]), _vm._v(" "), _vm._m(13, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('span', [_vm._v(_vm._s(_vm.totalAmount))])])])])], 2), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _vm._m(14, false, false), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.nextStep()
      }
    }
  }, [_vm._v("下一步")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step2),
      expression: "step2"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "1")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "1"
      }
    }
  }), _vm._v("\n                              ATM轉帳：使用實體ATM轉帳，手續費 15元\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "2")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "2"
      }
    }
  }), _vm._v("\n                              網路ATM：需備有讀卡機，手續費 15元\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "3")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "3"
      }
    }
  }), _vm._v("\n                              信用卡：手續費 2.75%\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "4")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "4"
      }
    }
  }), _vm._v("\n                              超商付款：7-11 iBon付款，手續費 20元\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "5",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "5")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "5"
      }
    }
  }), _vm._v("\n                              貨到付款\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cart_list"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("購物明細")]), _vm._v(" "), _vm._m(15, false, false), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "list_item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2 hidden-xs"
    }, [_c('figure', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-3"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.price) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.point) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.quantity) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.point * item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.price * item.quantity))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "pid[]"
      },
      domProps: {
        "value": item.id
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "qty[]"
      },
      domProps: {
        "value": item.quantity
      }
    })])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.UserCash > 0) ? _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 col-xs-3 label label-danger text-right",
    attrs: {
      "for": "inputDiscount"
    }
  }, [_vm._v("使用回饋金")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.discountInput == 1 ? true : false,
      "placeholder": "請輸入扣抵金額"
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-xs-3"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.discountInput == 1 ? true : false
    },
    on: {
      "click": function($event) {
        _vm.usedDiscount()
      }
    }
  }, [_vm._v("確認扣抵")]), _vm._v("\n                                          餘額: " + _vm._s(_vm.UserCash) + " 元\n                                      ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total_list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-7 col-sm-5 col-xs-12"
  }, [_c('p', [_vm._v("共 " + _vm._s(_vm.cart_items) + " 件，回饋點數: " + _vm._s(_vm.totalPoint) + " 點")])]), _vm._v(" "), _vm._m(16, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.orderAmount))])])]), _vm._v(" "), _vm._m(17, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.discount || 0))])])]), _vm._v(" "), _vm._m(18, false, false), _vm._v(" "), _vm._m(19, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.shippingFee))])])]), _vm._v(" "), _vm._m(20, false, false), _vm._v(" "), _vm._m(21, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.paymentFee))])])]), _vm._v(" "), _vm._m(22, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.invoiceFee))])])]), _vm._v(" "), _vm._m(23, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.totalAmount))])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingFee),
      expression: "shippingFee"
    }],
    attrs: {
      "type": "hidden",
      "name": "shippingFee"
    },
    domProps: {
      "value": (_vm.shippingFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingFee = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceFee),
      expression: "invoiceFee"
    }],
    attrs: {
      "type": "hidden",
      "name": "invoiceFee"
    },
    domProps: {
      "value": (_vm.invoiceFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceFee = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstbuy),
      expression: "firstbuy"
    }],
    attrs: {
      "type": "hidden",
      "name": "firstbuy"
    },
    domProps: {
      "value": (_vm.firstbuy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstbuy = $event.target.value
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("收件人資訊")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEmail),
      expression: "userEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.userEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(24, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserPhone),
      expression: "UserPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.UserPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputCoAdd"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyval),
      expression: "countyval"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "county"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.county), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "selected": option.val == _vm.countyval
      }
    }, [_vm._v("\n                                          " + _vm._s(option.text) + "\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtval),
      expression: "districtval"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "district"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.district), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "selected": option.val == _vm.districtval
      }
    }, [_vm._v("\n                                          " + _vm._s(option.text) + "\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserAddress),
      expression: "UserAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.UserAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserAddress = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "hidden",
      "name": "use_cash"
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userID),
      expression: "userID"
    }],
    attrs: {
      "type": "hidden",
      "name": "id"
    },
    domProps: {
      "value": (_vm.userID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("備註")]), _vm._v(" "), _vm._m(25, false, false), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _vm._m(26, false, false), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_vm._v("送出")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("購物車")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("訂購商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step_list text-center"
  }, [_c('ol', {
    staticClass: "list-inline step hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1. 購物明細")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2. 付款方式")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3. 完成訂購")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("物流方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("發票開立方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("統一編號")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "invoice_number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("抬頭")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "invoice_company"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("提示：")]), _vm._v(" 選擇到店自取，請務必先與店家聯絡確認取貨時間。\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart_head"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 hidden-xs"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品圖片")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-3"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品名稱")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("數量")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數小計")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價小計")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("刪除")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-6"
  }, [_c('p', [_vm._v("小計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-5 col-sm-2 text-right hidden-xs"
  }, [_c('p', [_vm._v("(運費類型)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-6"
  }, [_c('p', [_vm._v("運費")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-6"
  }, [_c('p', [_vm._v("稅金")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-6"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("總計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "notice_list"
  }, [_c('li', [_vm._v("請確認您填寫的資料是否正確，一旦訂單完成後，付款與物流方式皆無法修改。")]), _vm._v(" "), _c('li', [_vm._v("出貨方式，按照訂購區域與時間，依序進行出貨/排貨。")]), _vm._v(" "), _c('li', [_vm._v("若您對取貨或付款的方式有疑問，請詳閱「購物須知」。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart_head"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 hidden-xs"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品圖片")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-3"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品名稱")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("數量")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數小計")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價小計")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("小計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("回饋金折抵")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-5 col-sm-2 hidden-xs text-right"
  }, [_c('p', [_vm._v("(運費類型)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("運費")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-5 col-sm-2 hidden-xs text-right"
  }, [_c('p', [_vm._v("(金流類型)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("手續費")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("稅金")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-3"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("總計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputTime"
    }
  }, [_vm._v("配送時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "time"
    }
  }, [_c('option', {
    attrs: {
      "value": "不限時間"
    }
  }, [_vm._v("不限時間")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "上午"
    }
  }, [_vm._v("上午")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "下午"
    }
  }, [_vm._v("下午")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "placeholder": "備註",
      "rows": "5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "notice_list"
  }, [_c('li', [_vm._v("請確認您填寫的資料是否正確，一旦訂單完成後，付款與物流方式皆無法修改。")]), _vm._v(" "), _c('li', [_vm._v("出貨方式，按照訂購區域與時間，依序進行出貨/排貨。")]), _vm._v(" "), _c('li', [_vm._v("若您對取貨或付款的方式有疑問，請洽本公司客服電話。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da69e730"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShoppingCart.vue
// module id = 321
// module chunks = 1